import errorRoutes from './errors';
import {
  AboutUsView,
  CartView,
  ContactUsView,
  EventListView,
  EventShowView,
  FaqsView,
  ForEventOrganisersView,
  ForPhotographersView,
  PrivacyPolicyView,
  TermsOfUseView,
} from '@/views';

import {
  MyOrdersView,
  OrderConfirmationView,
  OrderDetailsLoginView,
  OrderDetailsView,
  OrderPublicView,
  PaymentFailureView,
  PaymentSuccessView,
} from '@/views/orders';

export default [
  ...errorRoutes,
  {
    path: '',
    name: 'app_event_list',
    component: EventListView,
    meta: { title: 'Welcome to SportPix' },
  },
  {
    path: '/events/:slug',
    name: 'app_event_show',
    component: EventShowView,
    meta: { title: 'Event' },
  },
  {
    path: '/privacy-policy',
    name: 'app_privacy_policy',
    component: PrivacyPolicyView,
    meta: { title: 'Privacy Policy' },
  },
  {
    path: '/terms-of-use',
    name: 'app_terms_of_use',
    component: TermsOfUseView,
    meta: { title: 'Terms of Use' },
  },
  {
    path: '/faqs',
    name: 'app_faqs',
    component: FaqsView,
    meta: { title: 'Frequently Asked Questions' },
  },
  {
    path: '/about-us',
    name: 'app_about_us',
    component: AboutUsView,
    meta: { title: 'About Us' },
  },
  {
    path: '/for-event-organisers',
    name: 'app_for_event_organisers',
    component: ForEventOrganisersView,
    meta: { title: 'For Event Organisers' },
  },
  {
    path: '/for-photographers',
    name: 'app_for_photographers',
    component: ForPhotographersView,
    meta: { title: 'For Photographers' },
  },
  {
    path: '/contact-us',
    name: 'app_contact_us',
    component: ContactUsView,
    meta: { title: 'Contact Us' },
  },
  {
    path: '/cart',
    name: 'app_cart',
    component: CartView,
    meta: { title: 'Cart' },
  },
  {
    path: '/cart/confirmation',
    name: 'app_cart_confirmation',
    component: OrderConfirmationView,
    meta: { title: 'Cart Confirmation', requiresAuthentication: true },
  },
  {
    path: '/orders/:order/payment/success',
    name: 'app_payment_success',
    component: PaymentSuccessView,
    meta: { title: 'Payment Success', requiresAuthentication: true },
  },
  {
    path: '/orders/:order/payment/failed',
    name: 'app_payment_failure',
    component: PaymentFailureView,
    meta: { title: 'Payment Failure', requiresAuthentication: true },
  },
  {
    path: '/orders',
    name: 'app_orders',
    component: MyOrdersView,
    meta: { title: 'My Orders', requiresAuthentication: true },
  },
  {
    path: '/orders/order-details/:order',
    name: 'app_order_details',
    component: OrderDetailsView,
    meta: { title: 'Order Details', requiresAuthentication: true },
  },
  {
    path: '/orders/shared/:share',
    name: 'app_order_public',
    component: OrderPublicView,
    meta: { title: 'Order Photos' },
  },
  {
    path: '/orders/order-details-login',
    name: 'app_order_details_login',
    component: OrderDetailsLoginView,
    meta: { title: 'Order Details' },
  },
];
